import { RadioGroup as NextRadioGroup } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const RadioGroup = withFormComponent(NextRadioGroup); 